import React, { useEffect, useState } from "react"
import { Box, useMediaQuery } from "@mui/material"
import { styled } from "@mui/material/styles"
import { useTheme } from "@mui/material/styles"

interface StyledContainerProps {
  isVisible: boolean
  isMobile: boolean
}

const StickyContainer = styled(Box)<StyledContainerProps>(({ isVisible, isMobile, theme }) => ({
  position: "fixed",
  width: "100%",
  minHeight: isMobile ? "80px" : "60px",
  background: theme.palette["secondary.800"].main,
  padding: theme.spacing(4, 6),
  zIndex: 1000,
  transition: theme.transitions.create(["transform", "opacity"]),
  boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.12)",
  bottom: 0,
  left: 0,
  transform: `translateY(${isVisible ? "0" : "100%"})`,
  display: "flex",
  alignItems: "center",
}))

interface StickyTripBannerWrapperProps {
  children: React.ReactNode
  targetElementHeight?: number
  className?: string
}

const StickyTripBannerWrapper: React.FC<StickyTripBannerWrapperProps> = ({
  children,
  className,
}) => {
  const [isVisible, setIsVisible] = useState(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY
      // show banner after we pass the hero section
      // use 500px threshold for mobile, 800px for desktop
      setIsVisible(scrollPosition > (isMobile ? 600 : 800))
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [isMobile])

  return (
    <StickyContainer isVisible={isVisible} isMobile={isMobile} className={className}>
      {children}
    </StickyContainer>
  )
}

export default StickyTripBannerWrapper
